/**
 * Application configuration
 * Environment variables are loaded from .env files based on the build mode
 */

export const config = {
  /**
   * Base URL for the Azure Functions API
   * Defaults to '/api' if not specified in environment variables
   * 
   * Development: http://localhost:7071/api (from .env.development)
   * Production: /api (from .env.production)
   * Custom: Set REACT_APP_API_BASE_URL in .env.local
   */
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL || '/api',
};

// Log configuration in development mode
if (process.env.NODE_ENV === 'development') {
  console.log('App Configuration:', {
    apiBaseUrl: config.apiBaseUrl,
    environment: process.env.NODE_ENV,
  });
}

export default config;
